
export default {
    bind: function (el, binding) {
        function handleScroll(res) {
          let fatTarget = res.target.clientHeight * 15 / 100;
          let bottom = (res.target.scrollHeight - res.target.scrollTop) - fatTarget <= res.target.clientHeight;
          if (bottom) {
            binding.value();
          }
        }
      
        el.addEventListener('scroll', handleScroll);
      
        // Remover o event listener quando o binding é atualizado ou quando o componente é destruído
        el._handleScroll = handleScroll; // Armazenar a referência da função no elemento
        el._binding = binding; // Armazenar o objeto de binding no elemento
    },
    unbind: function (el) {
        el.removeEventListener('scroll', el._handleScroll);
        delete el._handleScroll;
        delete el._binding;
    }
}
